import { useState,useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import {Article} from "../../data/types";
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const options = {
    cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
    standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts`,
  };
function PagePDF() {
  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [article, setArticle] = useState<Article>({image:'',date:'',titre: '', description: '',index:0,categorie:'',href:'',html:''})

    useEffect(() => {
      const getArticle = async () => {
        var response:any=[];
        try {
          response = await axiosInstance.get("api/articles"+window.location.pathname);
          setArticle(response.data);
        } catch (error) {
          console.log("erreur:"+error);
        }
      }
      getArticle();      
    }, [])

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }
  
  return (
    <div className='container'>
      <Document options={options} file={article.html} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from(new Array(numPages), (el, index) => (
      <Page object-fit="fill" key={`page_${index + 1}`} pageNumber={index + 1} />
    ))}
      </Document>
    </div>
  );
}

export default PagePDF;